var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8173 22.9801H4.5178C3.92576 22.9801 3.44613 22.5002 3.44613 21.9084V4.63489C3.44613 4.04293 3.92584 3.56323 4.5178 3.56323H21.7915C22.3833 3.56323 22.863 4.04293 22.863 4.63489V21.9084C22.863 22.5003 22.3832 22.9801 21.7915 22.9801H16.8435V15.4608H19.3674L19.7453 12.5304H16.8435V10.6596C16.8435 9.81114 17.0791 9.23297 18.2957 9.23297L19.8475 9.2323V6.61132C19.5791 6.57561 18.658 6.49582 17.5863 6.49582C15.349 6.49582 13.8173 7.86146 13.8173 10.3693V12.5304H11.287V15.4608H13.8173V22.9801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4653589d952fd5891aa252df671fb785.svg";
export { ForwardRef as ReactComponent };